import { createContext } from 'react';

import { Context } from '../../../types';
import { TravelFileAttribute } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

const contextValues = getContextDefaultValues(api);
const travelFileAttributesContext = createContext<Context<TravelFileAttribute>>(contextValues);

export default travelFileAttributesContext;
